 <div class="modalOverlay">
    <div class="modalPositioner" cvNavigationSidebarClass>
        <div class="modalContainer">

            <!-- Header -->
            <button type="button" class="icon-btn fill-valyrianSteel fill-hover-whaleTail modal-close" (click)="cancel()">
                <svg class="icon-16">
                    <use href="../../App_Themes/clearview-default/icons/utility/close.svg#close"></use>
                </svg>
            </button>
            <div class="modal-header">
                <span class="titleText" cvLocalizedText langSection="Subscription_Modal" langKey="Subscription_Title">Subscription</span>
            </div>
            <!-- Header End -->
            <!-- Body -->
            <div class="modal-body container">
                
                <!-- Loading Graphic -->
                <cv-loader [hidden]="!isLoading"></cv-loader>

                <!-- Frequency -->
                <div class="row title" cvLocalizedText langSection="Subscription_Modal" langKey="Recurrence">Recurrence</div>
                <br>
                <div class="row">
                    <div class="col-6 label" cvLocalizedText langSection="Subscription_Modal" langKey="Frequency">FREQUENCY</div>
                    <div class="col-6 label" *ngIf="selectedFrequency.value === 1" cvLocalizedText langSection="Subscription_Modal" langKey="DOW">DAYS OF THE WEEK</div>
                    <div class="col-6 label" *ngIf="selectedFrequency.value === 2" cvLocalizedText langSection="Subscription_Modal" langKey="DOM">DAYS OF THE MONTH</div>
                </div>

                <div class="row">
                    <div class="col-6">
                        <cxone-singleselect-dropdown
                            *ngIf="initialized"
                            id="frequency-dropdown-menu"
                            [(ngModel)]="selectedFrequency"
                            (ngModelChange)="onFrequencyChange()"
                            [options]="frequencies"
                            [label]="'name'"
                            [primaryKey]="'name'"
                            [isRequired]="false"
                            [sortOrder]="'unsort'"
                            [search]="false"
                            [showFooter]="false"
                            [maxItemsToDisplay]="1000">
                        </cxone-singleselect-dropdown>
                    </div>

                    <!-- Daily -->
                    <div class="col-6" *ngIf="selectedFrequency.value === 0">
                        <div class="row">
                            <div class="mr-2 pt-2" cvLocalizedText langSection="Subscription_Modal" langKey="Every">EVERY</div>
                            <cxone-numeric-selector
                                *ngIf="initialized"
                                [(ngModel)]="this.schedule.repeatOptions.repeatValue"
                                [step]="1"
                                [min]="1"
                                [max]="99">
                            </cxone-numeric-selector>
                            <div class="ml-2 pt-2" cvLocalizedText langSection="Subscription_Modal" langKey="Days">DAY(S)</div>
                        </div>
                    </div>

                    <!-- Weekly -->
                    <div class="col-6" *ngIf="selectedFrequency.value === 1">
                        <div class="row" *ngIf="initialized">
                            <cxone-checkbox class="col-3"
                                type="checkbox"
                                *ngFor="let day of daysOfWeek"
                                [(ngModel)]="day.selected"
                                (ngModelChange)="onSelectedDaysChange()"
                                labelText="{{day.shortName}}">
                            </cxone-checkbox>
                        </div>
                    </div>

                    <!-- Monthly -->
                    <div class="col-6" *ngIf="selectedFrequency.value === 2">
                        <cxone-multiselect-dropdown 
                            *ngIf="initialized"
                            [(ngModel)]="daysOfMonthSelected"
                            [options]="daysOfMonth"
                            [label]="'name'"
                            (selectionChanged)="onChangeSelectedDOM()"
                            [primaryKey]="'name'"
                            [sortOrder]="'unsort'"
                            [maxItemsToDisplay]="1000">
                        </cxone-multiselect-dropdown>
                    </div>
                </div>
                <br>
                <div class="row">
                    <div class="col-6 label" cvLocalizedText langSection="Subscription_Modal" langKey="At">AT</div>
                </div>
                <div class="row">
                    <!-- Time Picker -->
                    <cxone-time-picker 
                        *ngIf="initialized"
                        class="col-6"
                        [steps]="15"
                        [(ngModel)]="schedule.firstExportTime"
                        [format]="'hh:mm A'">
                    </cxone-time-picker>
                    <!-- Repeat Hourly Checkbox -->
                    <cxone-checkbox 
                        *ngIf="initialized"
                        class="col-6 align-self-center"
                        [hidden]="selectedFrequency.value === 0"
                        type="checkbox"
                        [(ngModel)]="repeatHourlySelected"
                        (ngModelChange)="onRepeatHourlyChanged()"
                        [labelText]="getRepeatHourlyText()">
                    </cxone-checkbox>
                </div>
                <br>
                <div class="row title" cvLocalizedText langSection="Subscription_Modal" langKey="Recipients">Recipients</div>
                <br>
                <div class="row">
                    <div class="col-6">
                        <cxone-checkbox
                            *ngIf="initialized"
                            type="checkbox"
                            [(ngModel)]="schedule.sendToMe"
                            labelText="{{getSendToMeText()}}">
                        </cxone-checkbox>
                    </div>
                </div>
                <!-- Frequency End -->
                <!-- Emails -->
                <div class="row">
                    <div class="col-6 label" cvLocalizedText langSection="Subscription_Modal" langKey="Emails">EMAIL ADDRESSES</div>
                </div>
                <div class="row mt-2">
                    <div class="col-6">
                        <form [formGroup]="emailForm" #emailform="ngForm" (ngSubmit)="add(emailform)">
                            <input 
                                class="email-input form-control"
                                type="text"
                                id="email"
                                formControlName="email"
                                required>
                        </form>
                    </div>
                </div>
                <div class="row">
                    <div class="col-6 warning" *ngIf="email.invalid && emailform.submitted && !email.value.endsWith('.')" cvLocalizedText langSection="Subscription_Modal" langKey="Invalid_Email">This email address is not valid</div>
                </div>
                <div class="row mt-1">
                    <div class="col-12" style="height: auto;">
                        <cxone-selected-tags 
                            id="emails-list"
                            *ngIf="initialized"
                            [tagsSource]="recipients"
                            primaryKey="text"
                            label="text"
                            [removable]="true" 
                            (tagDeleted)="remove($event)"
                            [maxTagsToDisplay]="9">
                        </cxone-selected-tags>
                    </div>
                </div>
                <br>
                <!-- Emails End -->
            </div>
            <!-- Body End -->
            <!-- Footer -->
            <div class="modal-footer">
                <button type="button" class="btn btn-text mr-2" (click)="cancel()" cvLocalizedText langSection="Common" langKey="Cancel_Button">Cancel</button>
                <button 
                    type="button" 
                    class="btn btn-primary" 
                    [disabled]="(!schedule.sendToMe && recipients.length === 0) || (this.selectedFrequency.value === 1 && checkSelectedWeeks()) || (this.selectedFrequency.value === 2 && this.daysOfMonthSelected.length === 0)" 
                    (click)="save()" 
                    cvLocalizedText langSection="Common" langKey="Subscribe">Subscribe</button>
            </div>
            <!-- Footer End -->
        </div>
    </div>
</div>
